import React from 'react';
import { FiArrowUpRight, FiMenu, FiX } from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';
import { KAKAO_TALK_URL, PROJECT_INQUIRY_URL } from '../constants/contact';

const navItems = [
  { id: 'services', label: '서비스', href: '/#services' },
  { id: 'portfolio-page', label: '포트폴리오', href: '/portfolio' },
  { id: 'maintenance', label: '유지보수', href: '/maintenance' },
  { id: 'tech', label: '기술 역량', href: '/#tech' },
];

const Header: React.FC<{
  isMenuOpen: boolean;
  onMenuToggle: () => void;
  onScrollToTop: () => void;
  onProjectInquiry: () => void;
}> = ({ isMenuOpen, onMenuToggle, onScrollToTop, onProjectInquiry }) => {
  const { pathname } = useLocation();
  const isPortfolioPage = pathname === '/portfolio' || pathname.startsWith('/portfolio/');
  const isMaintenancePage = pathname === '/maintenance';

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-[1200px] items-center gap-3 px-4 py-3 min-[361px]:px-5 min-[390px]:px-6 md:gap-6 md:px-4 md:py-4">
        <Link to="/" onClick={onScrollToTop} className="flex min-w-0 items-center gap-3 text-left text-slate-950">
          <img src="/brand-concepts/som/shift-05a-register.svg" alt="솜니움라이브 로고" className="h-10 w-10 shrink-0 object-contain md:h-11 md:w-11" />
          <span className="min-w-0">
            <span className="block truncate text-[15px] font-bold tracking-[0.14em] min-[361px]:text-base md:text-lg md:tracking-[0.18em]">SOMNIUM LIVE</span>
            <span className="block truncate text-[10px] font-medium text-slate-500 min-[361px]:text-[11px] md:text-xs">Web · App · Backend Development</span>
          </span>
        </Link>

        <div className="ml-auto flex shrink-0 items-center gap-3 lg:gap-8">
          <nav className="hidden items-center gap-8 lg:flex xl:gap-9">
            {navItems.map((item) => {
              const active = (item.id === 'portfolio-page' && isPortfolioPage) || (item.id === 'maintenance' && isMaintenancePage);
              return (
                <Link key={item.id} to={item.href} className={`text-sm font-semibold transition ${active ? 'text-[#005322]' : 'text-slate-600 hover:text-[#005322]'}`}>
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <Link to={PROJECT_INQUIRY_URL} onClick={onProjectInquiry} className="hidden h-11 items-center justify-center gap-2 border border-[#005322] bg-[#005322] px-6 text-sm font-semibold text-white transition hover:bg-[#003a18] lg:inline-flex">
            프로젝트 문의하기 <FiArrowUpRight className="text-base" />
          </Link>

          <button type="button" onClick={onMenuToggle} className="inline-flex h-10 w-10 shrink-0 items-center justify-center border border-slate-200 text-slate-800 min-[361px]:h-11 min-[361px]:w-11 lg:hidden" aria-label={isMenuOpen ? '메뉴 닫기' : '메뉴 열기'}>
            {isMenuOpen ? <FiX className="text-xl" /> : <FiMenu className="text-xl" />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="border-t border-slate-200 bg-white py-4 lg:hidden">
          <nav className="mx-auto space-y-4 px-4">
            {navItems.map((item) => {
              const active = (item.id === 'portfolio-page' && isPortfolioPage) || (item.id === 'maintenance' && isMaintenancePage);
              return (
                <Link key={item.id} to={item.href} onClick={onMenuToggle} className={`block border-b border-slate-100 pb-4 font-semibold ${active ? 'text-[#005322]' : 'text-slate-700 hover:text-[#005322]'}`}>
                  {item.label}
                </Link>
              );
            })}
            <Link to={PROJECT_INQUIRY_URL} onClick={() => { onMenuToggle(); onProjectInquiry(); }} className="hidden h-11 items-center justify-center gap-2 border border-[#005322] bg-[#005322] px-5 text-sm font-semibold text-white md:inline-flex">
              프로젝트 문의하기 <FiArrowUpRight className="text-base" />
            </Link>
            <a href={KAKAO_TALK_URL} target="_blank" rel="noopener noreferrer" onClick={onMenuToggle} className="inline-flex h-11 items-center justify-center gap-2 border border-[#005322] bg-[#005322] px-5 text-sm font-semibold text-white md:hidden">
              카카오톡 상담 <FiArrowUpRight className="text-base" />
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
